/**
 * Chroma subsampling format
 * @enum {0 | 1 | 2 | 3}
 */
export const ChromaSampling = Object.freeze({
    /**
     * Both vertically and horizontally subsampled.
     */
    Cs420: 0, "0": "Cs420",
    /**
     * Horizontally subsampled.
     */
    Cs422: 1, "1": "Cs422",
    /**
     * Not subsampled.
     */
    Cs444: 2, "2": "Cs444",
    /**
     * Monochrome.
     */
    Cs400: 3, "3": "Cs400",
});

export class WasmEditorHandle {
    static __wrap(ptr) {
        const obj = Object.create(WasmEditorHandle.prototype);
        obj.__wbg_ptr = ptr;
        WasmEditorHandleFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmEditorHandleFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmeditorhandle_free(ptr, 0);
    }
    /**
     * @param {string} label
     */
    beginEdit(label) {
        const ptr0 = passStringToWasm0(label, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wasmeditorhandle_beginEdit(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {boolean}
     */
    canRedo() {
        const ret = wasm.wasmeditorhandle_canRedo(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    canUndo() {
        const ret = wasm.wasmeditorhandle_canUndo(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    cancelEdit() {
        const ret = wasm.wasmeditorhandle_cancelEdit(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    commitEdit() {
        const ret = wasm.wasmeditorhandle_commitEdit(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} command_json
     * @returns {boolean}
     */
    dispatchOpen(command_json) {
        const ptr0 = passStringToWasm0(command_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wasmeditorhandle_dispatchOpen(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * @param {string} command_json
     * @param {string} label
     * @returns {boolean}
     */
    dispatchWithLabel(command_json, label) {
        const ptr0 = passStringToWasm0(command_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(label, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wasmeditorhandle_dispatchWithLabel(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * @param {string} command_json
     * @returns {boolean}
     */
    dispatch(command_json) {
        const ptr0 = passStringToWasm0(command_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wasmeditorhandle_dispatch(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * @returns {number}
     */
    durationUs() {
        const ret = wasm.wasmeditorhandle_durationUs(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {string} json
     * @returns {WasmEditorHandle}
     */
    static fromJson(json) {
        const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wasmeditorhandle_fromJson(ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return WasmEditorHandle.__wrap(ret[0]);
    }
    /**
     * @returns {string}
     */
    historyEntries() {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = wasm.wasmeditorhandle_historyEntries(this.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {number} index
     * @returns {boolean}
     */
    jumpToHistory(index) {
        const ret = wasm.wasmeditorhandle_jumpToHistory(this.__wbg_ptr, index);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * @param {string} name
     */
    constructor(name) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.wasmeditorhandle_new(ptr0, len0);
        this.__wbg_ptr = ret;
        WasmEditorHandleFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {number}
     */
    playheadUs() {
        const ret = wasm.wasmeditorhandle_playheadUs(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {string} clip_id
     * @param {string} keyframes_json
     * @returns {number}
     */
    predictedSpeedCurveDurationUs(clip_id, keyframes_json) {
        const ptr0 = passStringToWasm0(clip_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(keyframes_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wasmeditorhandle_predictedSpeedCurveDurationUs(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0];
    }
    /**
     * @returns {number}
     */
    redoDepth() {
        const ret = wasm.wasmeditorhandle_redoDepth(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string | undefined}
     */
    redoLabel() {
        const ret = wasm.wasmeditorhandle_redoLabel(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]);
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {boolean}
     */
    redo() {
        const ret = wasm.wasmeditorhandle_redo(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * @param {number} width
     * @param {number} height
     * @returns {string}
     */
    renderPlanAtPlayhead(width, height) {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = wasm.wasmeditorhandle_renderPlanAtPlayhead(this.__wbg_ptr, width, height);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @param {number} timestamp_us
     * @param {number} width
     * @param {number} height
     * @param {boolean} hardware_acceleration
     * @param {string | null} [ignore_crop_clip_id]
     * @returns {string}
     */
    renderPreviewFrame(timestamp_us, width, height, hardware_acceleration, ignore_crop_clip_id) {
        let deferred3_0;
        let deferred3_1;
        try {
            var ptr0 = isLikeNone(ignore_crop_clip_id) ? 0 : passStringToWasm0(ignore_crop_clip_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len0 = WASM_VECTOR_LEN;
            const ret = wasm.wasmeditorhandle_renderPreviewFrame(this.__wbg_ptr, timestamp_us, width, height, hardware_acceleration, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0; len2 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * @param {number} us
     */
    setPlayheadUs(us) {
        wasm.wasmeditorhandle_setPlayheadUs(this.__wbg_ptr, us);
    }
    /**
     * @returns {string}
     */
    toJson() {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = wasm.wasmeditorhandle_toJson(this.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @returns {boolean}
     */
    transactionOpen() {
        const ret = wasm.wasmeditorhandle_transactionOpen(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {number}
     */
    undoDepth() {
        const ret = wasm.wasmeditorhandle_undoDepth(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string | undefined}
     */
    undoLabel() {
        const ret = wasm.wasmeditorhandle_undoLabel(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]);
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {boolean}
     */
    undo() {
        const ret = wasm.wasmeditorhandle_undo(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * @param {number} width
     * @param {number} height
     * @returns {string}
     */
    validateRenderPlanAtPlayhead(width, height) {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = wasm.wasmeditorhandle_validateRenderPlanAtPlayhead(this.__wbg_ptr, width, height);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0; len1 = 0;
                throw takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
}
if (Symbol.dispose) WasmEditorHandle.prototype[Symbol.dispose] = WasmEditorHandle.prototype.free;

export class WasmExportSession {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmExportSessionFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmexportsession_free(ptr, 0);
    }
    cancel() {
        wasm.wasmexportsession_cancel(this.__wbg_ptr);
    }
    /**
     * @returns {number}
     */
    getProgress() {
        const ret = wasm.wasmexportsession_getProgress(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {boolean}
     */
    isDone() {
        const ret = wasm.wasmexportsession_isDone(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {string} project_json
     * @param {string} output_path
     */
    constructor(project_json, output_path) {
        const ptr0 = passStringToWasm0(project_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(output_path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.wasmexportsession_new(ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0];
        WasmExportSessionFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Process one batch of frames. Returns JSON:
     * `{"ok":true,"done":false,"progress":50000}` or
     * `{"ok":true,"done":true,"payload":{"ok":true,"bytesBase64":"...","fileName":"...","mimeType":"..."}}` or
     * `{"ok":false,"error":"..."}`
     * @returns {Promise<any>}
     */
    processChunk() {
        const ret = wasm.wasmexportsession_processChunk(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) WasmExportSession.prototype[Symbol.dispose] = WasmExportSession.prototype.free;

/**
 * @param {string} rgba_base64
 * @param {number} width
 * @param {number} height
 * @param {string} masks_json
 * @returns {string}
 */
export function applyMasks(rgba_base64, width, height, masks_json) {
    let deferred4_0;
    let deferred4_1;
    try {
        const ptr0 = passStringToWasm0(rgba_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(masks_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.applyMasks(ptr0, len0, width, height, ptr1, len1);
        var ptr3 = ret[0];
        var len3 = ret[1];
        if (ret[3]) {
            ptr3 = 0; len3 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred4_0 = ptr3;
        deferred4_1 = len3;
        return getStringFromWasm0(ptr3, len3);
    } finally {
        wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
    }
}

export function cancelExport() {
    wasm.cancelExport();
}

export function clearExportPreview() {
    wasm.clearExportPreview();
}

/**
 * WASM twin of the native `detect_beats`: onset detection over a
 * registered in-memory file (browser picks have no fs path).
 * @param {string} path
 * @returns {string}
 */
export function detectBeats(path) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.detectBeats(ptr0, len0);
        var ptr2 = ret[0];
        var len2 = ret[1];
        if (ret[3]) {
            ptr2 = 0; len2 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred3_0 = ptr2;
        deferred3_1 = len2;
        return getStringFromWasm0(ptr2, len2);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

/**
 * @returns {string}
 */
export function exportPreviewFrame() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.exportPreviewFrame();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @returns {number}
 */
export function exportProgress() {
    const ret = wasm.exportProgress();
    return ret >>> 0;
}

/**
 * @param {string} project_json
 * @param {string} output_path
 * @returns {string}
 */
export function exportProjectBlob(project_json, output_path) {
    let deferred4_0;
    let deferred4_1;
    try {
        const ptr0 = passStringToWasm0(project_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(output_path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.exportProjectBlob(ptr0, len0, ptr1, len1);
        var ptr3 = ret[0];
        var len3 = ret[1];
        if (ret[3]) {
            ptr3 = 0; len3 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred4_0 = ptr3;
        deferred4_1 = len3;
        return getStringFromWasm0(ptr3, len3);
    } finally {
        wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
    }
}

/**
 * @param {string} project_json
 * @param {string} output_path
 * @returns {boolean}
 */
export function exportProjectJson(project_json, output_path) {
    const ptr0 = passStringToWasm0(project_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(output_path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.exportProjectJson(ptr0, len0, ptr1, len1);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return ret[0] !== 0;
}

/**
 * @param {string} path
 * @param {number} target_us
 * @param {boolean} hardware_acceleration
 * @returns {Promise<string>}
 */
export function extractThumbnail(path, target_us, hardware_acceleration) {
    const ptr0 = passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.extractThumbnail(ptr0, len0, target_us, hardware_acceleration);
    return ret;
}

/**
 * @param {string} path
 * @param {number} count
 * @param {number} duration_us
 * @param {boolean} hardware_acceleration
 * @returns {Promise<string>}
 */
export function extractThumbnails(path, count, duration_us, hardware_acceleration) {
    const ptr0 = passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.extractThumbnails(ptr0, len0, count, duration_us, hardware_acceleration);
    return ret;
}

/**
 * @param {string} path
 * @param {number} buckets
 * @returns {string}
 */
export function extractWaveform(path, buckets) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.extractWaveform(ptr0, len0, buckets);
        var ptr2 = ret[0];
        var len2 = ret[1];
        if (ret[3]) {
            ptr2 = 0; len2 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred3_0 = ptr2;
        deferred3_1 = len2;
        return getStringFromWasm0(ptr2, len2);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

export function init() {
    wasm.init();
}

/**
 * Probes whether the browser's WebCodecs VideoDecoder can use
 * `hardwareAcceleration: "prefer-hardware"` for common codecs.
 * @returns {Promise<boolean>}
 */
export function isWebCodecsHardwareAccelerated() {
    const ret = wasm.isWebCodecsHardwareAccelerated();
    return ret;
}

/**
 * @param {string} path
 * @returns {string}
 */
export function mediaBlobUrl(path) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mediaBlobUrl(ptr0, len0);
        var ptr2 = ret[0];
        var len2 = ret[1];
        if (ret[3]) {
            ptr2 = 0; len2 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred3_0 = ptr2;
        deferred3_1 = len2;
        return getStringFromWasm0(ptr2, len2);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

/**
 * @param {string} path
 * @returns {string}
 */
export function probeAudio(path) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.probeAudio(ptr0, len0);
        var ptr2 = ret[0];
        var len2 = ret[1];
        if (ret[3]) {
            ptr2 = 0; len2 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred3_0 = ptr2;
        deferred3_1 = len2;
        return getStringFromWasm0(ptr2, len2);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

/**
 * @param {string} path
 * @returns {string}
 */
export function probeVideo(path) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.probeVideo(ptr0, len0);
        var ptr2 = ret[0];
        var len2 = ret[1];
        if (ret[3]) {
            ptr2 = 0; len2 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred3_0 = ptr2;
        deferred3_1 = len2;
        return getStringFromWasm0(ptr2, len2);
    } finally {
        wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}

/**
 * @param {string} path
 * @param {string} bytes_base64
 * @param {string | null} [extension]
 * @returns {boolean}
 */
export function registerFile(path, bytes_base64, extension) {
    const ptr0 = passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(bytes_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    var ptr2 = isLikeNone(extension) ? 0 : passStringToWasm0(extension, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len2 = WASM_VECTOR_LEN;
    const ret = wasm.registerFile(ptr0, len0, ptr1, len1, ptr2, len2);
    return ret !== 0;
}

/**
 * @param {string} url
 */
export function revokeBlobUrl(url) {
    const ptr0 = passStringToWasm0(url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.revokeBlobUrl(ptr0, len0);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

/**
 * @param {string} path
 * @param {number} timestamp_us
 * @returns {string | undefined}
 */
export function subtitleTextAt(path, timestamp_us) {
    const ptr0 = passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.subtitleTextAt(ptr0, len0, timestamp_us);
    let v2;
    if (ret[0] !== 0) {
        v2 = getStringFromWasm0(ret[0], ret[1]);
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v2;
}

/**
 * Reports whether the most recent WASM export used hardware acceleration
 * @returns {boolean}
 */
export function wasExportHardwareAccelerated() {
    const ret = wasm.wasExportHardwareAccelerated();
    return ret !== 0;
}
export function __wbg___wbindgen_debug_string_4687d8d8c2017d52(arg0, arg1) {
    const ret = debugString(arg1);
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}
export function __wbg___wbindgen_is_falsy_16bd49b68658263e(arg0) {
    const ret = !arg0;
    return ret;
}
export function __wbg___wbindgen_is_function_1f9d30630b8b1d3d(arg0) {
    const ret = typeof(arg0) === 'function';
    return ret;
}
export function __wbg___wbindgen_is_undefined_8865fb403f8fe9d8(arg0) {
    const ret = arg0 === undefined;
    return ret;
}
export function __wbg___wbindgen_throw_41e9ee4f547fc59a(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
}
export function __wbg__wbg_cb_unref_dcc1a90847f04c41(arg0) {
    arg0._wbg_cb_unref();
}
export function __wbg_allocationSize_d4e43c1cc6f9ba7e() { return handleError(function (arg0) {
    const ret = arg0.allocationSize();
    return ret;
}, arguments); }
export function __wbg_appendChild_fb8c52e7dd8484ea() { return handleError(function (arg0, arg1) {
    const ret = arg0.appendChild(arg1);
    return ret;
}, arguments); }
export function __wbg_body_e549239eaff082e1(arg0) {
    const ret = arg0.body;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}
export function __wbg_byteLength_9f985b8373f1f3fe(arg0) {
    const ret = arg0.byteLength;
    return ret;
}
export function __wbg_byteLength_ea18efca75249769(arg0) {
    const ret = arg0.byteLength;
    return ret;
}
export function __wbg_call_187d372bd5fdd4aa() { return handleError(function (arg0, arg1, arg2) {
    const ret = arg0.call(arg1, arg2);
    return ret;
}, arguments); }
export function __wbg_click_d990e70c576b7c54(arg0) {
    arg0.click();
}
export function __wbg_close_1f2973155994f1fb(arg0) {
    arg0.close();
}
export function __wbg_configure_05da88c43c13964f() { return handleError(function (arg0, arg1) {
    arg0.configure(arg1);
}, arguments); }
export function __wbg_configure_2d7bd366914c6c54() { return handleError(function (arg0, arg1) {
    arg0.configure(arg1);
}, arguments); }
export function __wbg_copyTo_053c4f8aa7bfc0d6() { return handleError(function (arg0, arg1, arg2) {
    arg0.copyTo(getArrayU8FromWasm0(arg1, arg2));
}, arguments); }
export function __wbg_copyTo_75461c0f3a7da370(arg0, arg1, arg2) {
    const ret = arg0.copyTo(getArrayU8FromWasm0(arg1, arg2));
    return ret;
}
export function __wbg_createElement_74049073a11f9c31() { return handleError(function (arg0, arg1, arg2) {
    const ret = arg0.createElement(getStringFromWasm0(arg1, arg2));
    return ret;
}, arguments); }
export function __wbg_createObjectURL_2f3b38279fe61801() { return handleError(function (arg0, arg1) {
    const ret = URL.createObjectURL(arg1);
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}, arguments); }
export function __wbg_debug_52bda05ddf50b736(arg0) {
    console.debug(arg0);
}
export function __wbg_decode_b38079ebec6f52e2() { return handleError(function (arg0, arg1) {
    arg0.decode(arg1);
}, arguments); }
export function __wbg_displayHeight_903e670be87f29ab(arg0) {
    const ret = arg0.displayHeight;
    return ret;
}
export function __wbg_displayWidth_5da2bf55e335368a(arg0) {
    const ret = arg0.displayWidth;
    return ret;
}
export function __wbg_document_9854e03c05fc8834(arg0) {
    const ret = arg0.document;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}
export function __wbg_encode_cc9f52ab5877b6cf() { return handleError(function (arg0, arg1, arg2) {
    arg0.encode(arg1, arg2);
}, arguments); }
export function __wbg_error_757e9472f8410341(arg0, arg1) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg0;
        deferred0_1 = arg1;
        console.error(getStringFromWasm0(arg0, arg1));
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
}
export function __wbg_error_c9cf3fc2064683a9(arg0) {
    console.error(arg0);
}
export function __wbg_flush_da2af3ca0e0b8a9b(arg0) {
    const ret = arg0.flush();
    return ret;
}
export function __wbg_format_b4d037a79565785c(arg0) {
    const ret = arg0.format;
    return isLikeNone(ret) ? 24 : ((__wbindgen_enum_VideoPixelFormat.indexOf(ret) + 1 || 24) - 1);
}
export function __wbg_getRandomValues_973dabfb0ad1769f() { return handleError(function (arg0, arg1) {
    globalThis.crypto.getRandomValues(getArrayU8FromWasm0(arg0, arg1));
}, arguments); }
export function __wbg_get_31af05bd4842a84f() { return handleError(function (arg0, arg1) {
    const ret = Reflect.get(arg0, arg1);
    return ret;
}, arguments); }
export function __wbg_get_codec_25fb9dd6492a4d80(arg0, arg1) {
    const ret = arg1.codec;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}
export function __wbg_get_coded_height_794634247832d0fd(arg0) {
    const ret = arg0.codedHeight;
    return isLikeNone(ret) ? Number.MAX_SAFE_INTEGER : (ret) >>> 0;
}
export function __wbg_get_coded_width_4d056b782363ee48(arg0) {
    const ret = arg0.codedWidth;
    return isLikeNone(ret) ? Number.MAX_SAFE_INTEGER : (ret) >>> 0;
}
export function __wbg_get_color_space_c764c664df00fd77(arg0) {
    const ret = arg0.colorSpace;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}
export function __wbg_get_description_184d83648e44a81e(arg0) {
    const ret = arg0.description;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}
export function __wbg_get_display_aspect_height_ae6f426c9e6e189d(arg0) {
    const ret = arg0.displayAspectHeight;
    return isLikeNone(ret) ? Number.MAX_SAFE_INTEGER : (ret) >>> 0;
}
export function __wbg_get_display_aspect_width_a12bd802bf0ca90f(arg0) {
    const ret = arg0.displayAspectWidth;
    return isLikeNone(ret) ? Number.MAX_SAFE_INTEGER : (ret) >>> 0;
}
export function __wbg_get_hardware_acceleration_b5a6c386ca0b2f77(arg0) {
    const ret = arg0.hardwareAcceleration;
    return isLikeNone(ret) ? 4 : ((__wbindgen_enum_HardwareAcceleration.indexOf(ret) + 1 || 4) - 1);
}
export function __wbg_get_optimize_for_latency_eee5127b83888752(arg0) {
    const ret = arg0.optimizeForLatency;
    return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
}
export function __wbg_get_supported_518f23b99b12bd82(arg0) {
    const ret = arg0.supported;
    return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
}
export function __wbg_height_c9feb8f4a9a61abc(arg0) {
    const ret = arg0.height;
    return ret;
}
export function __wbg_info_26925f73a2eee895(arg0) {
    console.info(arg0);
}
export function __wbg_instanceof_HtmlAnchorElement_e2e601da36602959(arg0) {
    let result;
    try {
        result = arg0 instanceof HTMLAnchorElement;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
}
export function __wbg_instanceof_Object_67a83cdc00c5d141(arg0) {
    let result;
    try {
        result = arg0 instanceof Object;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
}
export function __wbg_instanceof_Window_82d71df4eddf88bc(arg0) {
    let result;
    try {
        result = arg0 instanceof Window;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
}
export function __wbg_isConfigSupported_85a311035e295012(arg0) {
    const ret = VideoDecoder.isConfigSupported(arg0);
    return ret;
}
export function __wbg_length_7f3c00c40364105e(arg0) {
    const ret = arg0.length;
    return ret;
}
export function __wbg_log_17c30ef363c61cf4(arg0) {
    console.log(arg0);
}
export function __wbg_new_1dbf7428bba60a42(arg0) {
    const ret = new Uint8Array(arg0);
    return ret;
}
export function __wbg_new_227d7c05414eb861() {
    const ret = new Error();
    return ret;
}
export function __wbg_new_250d7f9408a7a446() { return handleError(function (arg0) {
    const ret = new VideoDecoder(arg0);
    return ret;
}, arguments); }
export function __wbg_new_5502aad30c185fc8(arg0, arg1) {
    try {
        var state0 = {a: arg0, b: arg1};
        var cb0 = (arg0, arg1) => {
            const a = state0.a;
            state0.a = 0;
            try {
                return wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined_______true_(a, state0.b, arg0, arg1);
            } finally {
                state0.a = a;
            }
        };
        const ret = new Promise(cb0);
        return ret;
    } finally {
        state0.a = 0;
    }
}
export function __wbg_new_617a8cdb8bb1130e() {
    const ret = new Object();
    return ret;
}
export function __wbg_new_94c269ca05f8dbb8() { return handleError(function (arg0) {
    const ret = new VideoEncoder(arg0);
    return ret;
}, arguments); }
export function __wbg_new_c800107a985d1494() { return handleError(function (arg0) {
    const ret = new EncodedVideoChunk(arg0);
    return ret;
}, arguments); }
export function __wbg_new_ee2291f50781bf1d() {
    const ret = new Array();
    return ret;
}
export function __wbg_new_from_slice_9a868026ffa4208a(arg0, arg1) {
    const ret = new Uint8Array(getArrayU8FromWasm0(arg0, arg1));
    return ret;
}
export function __wbg_new_typed_b01cb72a8af741a3(arg0, arg1) {
    try {
        var state0 = {a: arg0, b: arg1};
        var cb0 = (arg0, arg1) => {
            const a = state0.a;
            state0.a = 0;
            try {
                return wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined_______true_(a, state0.b, arg0, arg1);
            } finally {
                state0.a = a;
            }
        };
        const ret = new Promise(cb0);
        return ret;
    } finally {
        state0.a = 0;
    }
}
export function __wbg_new_with_u8_array_and_video_frame_buffer_init_678bf1fafc897dac() { return handleError(function (arg0, arg1) {
    const ret = new VideoFrame(arg0, arg1);
    return ret;
}, arguments); }
export function __wbg_new_with_u8_array_sequence_and_options_fccc08fe93f4b8fd() { return handleError(function (arg0, arg1) {
    const ret = new Blob(arg0, arg1);
    return ret;
}, arguments); }
export function __wbg_now_aa4ccb83129e9e55() {
    const ret = Date.now();
    return ret;
}
export function __wbg_prototypesetcall_bc27214492979395(arg0, arg1, arg2) {
    Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), arg2);
}
export function __wbg_push_2baf45db356cf468(arg0, arg1) {
    const ret = arg0.push(arg1);
    return ret;
}
export function __wbg_queueMicrotask_9833f9a49df95a49(arg0) {
    const ret = arg0.queueMicrotask;
    return ret;
}
export function __wbg_queueMicrotask_a72f977e97f23c5f(arg0) {
    queueMicrotask(arg0);
}
export function __wbg_removeChild_3745fc2545da50fa() { return handleError(function (arg0, arg1) {
    const ret = arg0.removeChild(arg1);
    return ret;
}, arguments); }
export function __wbg_resolve_0076e10020304ede(arg0) {
    const ret = Promise.resolve(arg0);
    return ret;
}
export function __wbg_revokeObjectURL_479ff72c2d109d80() { return handleError(function (arg0, arg1) {
    URL.revokeObjectURL(getStringFromWasm0(arg0, arg1));
}, arguments); }
export function __wbg_setProperty_097bc3d55ce44513() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    arg0.setProperty(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
}, arguments); }
export function __wbg_setTimeout_db7bbc18a17e152a() { return handleError(function (arg0, arg1, arg2) {
    const ret = arg0.setTimeout(arg1, arg2);
    return ret;
}, arguments); }
export function __wbg_set_145a351398b48c65() { return handleError(function (arg0, arg1, arg2) {
    const ret = Reflect.set(arg0, arg1, arg2);
    return ret;
}, arguments); }
export function __wbg_set_bitrate_12654950835b1903(arg0, arg1) {
    arg0.bitrate = arg1 >>> 0;
}
export function __wbg_set_codec_d38facaae49346a2(arg0, arg1, arg2) {
    arg0.codec = getStringFromWasm0(arg1, arg2);
}
export function __wbg_set_codec_ed40ae22dc4e3c23(arg0, arg1, arg2) {
    arg0.codec = getStringFromWasm0(arg1, arg2);
}
export function __wbg_set_coded_height_8e3bbba2a977ebe0(arg0, arg1) {
    arg0.codedHeight = arg1 >>> 0;
}
export function __wbg_set_coded_height_b28fa45124be2f2c(arg0, arg1) {
    arg0.codedHeight = arg1 >>> 0;
}
export function __wbg_set_coded_width_569d1c6c3f760811(arg0, arg1) {
    arg0.codedWidth = arg1 >>> 0;
}
export function __wbg_set_coded_width_674e7266b7356b62(arg0, arg1) {
    arg0.codedWidth = arg1 >>> 0;
}
export function __wbg_set_color_space_570a59dfef05abe3(arg0, arg1) {
    arg0.colorSpace = arg1;
}
export function __wbg_set_data_cfaec8acc3174ae1(arg0, arg1) {
    arg0.data = arg1;
}
export function __wbg_set_description_96d8a4d69f49308c(arg0, arg1) {
    arg0.description = arg1;
}
export function __wbg_set_display_aspect_height_185aea1383c567f6(arg0, arg1) {
    arg0.displayAspectHeight = arg1 >>> 0;
}
export function __wbg_set_display_aspect_width_1793b8ececbee546(arg0, arg1) {
    arg0.displayAspectWidth = arg1 >>> 0;
}
export function __wbg_set_download_327e0fbad75893f0(arg0, arg1, arg2) {
    arg0.download = getStringFromWasm0(arg1, arg2);
}
export function __wbg_set_error_59e5a105cacc733d(arg0, arg1) {
    arg0.error = arg1;
}
export function __wbg_set_error_e97906e3d5d8a297(arg0, arg1) {
    arg0.error = arg1;
}
export function __wbg_set_format_36fc7dc0296ace72(arg0, arg1) {
    arg0.format = __wbindgen_enum_VideoPixelFormat[arg1];
}
export function __wbg_set_framerate_8348c1e831341801(arg0, arg1) {
    arg0.framerate = arg1;
}
export function __wbg_set_hardware_acceleration_c016d11df54fb9b6(arg0, arg1) {
    arg0.hardwareAcceleration = __wbindgen_enum_HardwareAcceleration[arg1];
}
export function __wbg_set_height_20896240e4f2fac0(arg0, arg1) {
    arg0.height = arg1 >>> 0;
}
export function __wbg_set_href_f7219c6cbf6bedc3(arg0, arg1, arg2) {
    arg0.href = getStringFromWasm0(arg1, arg2);
}
export function __wbg_set_key_frame_e4a1ca6c7c83641b(arg0, arg1) {
    arg0.keyFrame = arg1 !== 0;
}
export function __wbg_set_latency_mode_894d87b789031fa8(arg0, arg1) {
    arg0.latencyMode = __wbindgen_enum_LatencyMode[arg1];
}
export function __wbg_set_optimize_for_latency_fd3b7b1c37948f61(arg0, arg1) {
    arg0.optimizeForLatency = arg1 !== 0;
}
export function __wbg_set_output_1c36a2ff0dfde551(arg0, arg1) {
    arg0.output = arg1;
}
export function __wbg_set_output_f825a5ea4eda555c(arg0, arg1) {
    arg0.output = arg1;
}
export function __wbg_set_timestamp_6e8a3d77568933dd(arg0, arg1) {
    arg0.timestamp = arg1;
}
export function __wbg_set_timestamp_f64_fd6034cbdb4706cf(arg0, arg1) {
    arg0.timestamp = arg1;
}
export function __wbg_set_type_1a91aca18d1b70c7(arg0, arg1) {
    arg0.type = __wbindgen_enum_EncodedVideoChunkType[arg1];
}
export function __wbg_set_type_dcf75b2afa60c694(arg0, arg1, arg2) {
    arg0.type = getStringFromWasm0(arg1, arg2);
}
export function __wbg_set_width_160d291d5de1a0f4(arg0, arg1) {
    arg0.width = arg1 >>> 0;
}
export function __wbg_stack_3b0d974bbf31e44f(arg0, arg1) {
    const ret = arg1.stack;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}
export function __wbg_state_7578672ae2ac06ed(arg0) {
    const ret = arg0.state;
    return (__wbindgen_enum_CodecState.indexOf(ret) + 1 || 4) - 1;
}
export function __wbg_state_87bb61ed2d0af787(arg0) {
    const ret = arg0.state;
    return (__wbindgen_enum_CodecState.indexOf(ret) + 1 || 4) - 1;
}
export function __wbg_static_accessor_GLOBAL_266715b9d96ba635() {
    const ret = typeof global === 'undefined' ? null : global;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}
export function __wbg_static_accessor_GLOBAL_THIS_10fb7dc1ae063179() {
    const ret = typeof globalThis === 'undefined' ? null : globalThis;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}
export function __wbg_static_accessor_SELF_0b583911f537483a() {
    const ret = typeof self === 'undefined' ? null : self;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}
export function __wbg_static_accessor_WINDOW_d7f903d1508cbdc4() {
    const ret = typeof window === 'undefined' ? null : window;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}
export function __wbg_style_4bce24230e493a7c(arg0) {
    const ret = arg0.style;
    return ret;
}
export function __wbg_then_c949d5a25a4e78f8(arg0, arg1, arg2) {
    const ret = arg0.then(arg1, arg2);
    return ret;
}
export function __wbg_then_e71170d78fcf8954(arg0, arg1) {
    const ret = arg0.then(arg1);
    return ret;
}
export function __wbg_timestamp_36d7101f77f3da23(arg0) {
    const ret = arg0.timestamp;
    return ret;
}
export function __wbg_timestamp_d747155251495239(arg0) {
    const ret = arg0.timestamp;
    return ret;
}
export function __wbg_type_dc1c2ae4e4dd9aae(arg0) {
    const ret = arg0.type;
    return (__wbindgen_enum_EncodedVideoChunkType.indexOf(ret) + 1 || 3) - 1;
}
export function __wbg_visibleRect_680e8c6a6bec7a37(arg0) {
    const ret = arg0.visibleRect;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}
export function __wbg_warn_13abc63e0d4b3527(arg0) {
    console.warn(arg0);
}
export function __wbg_width_bf3733dbc880874d(arg0) {
    const ret = arg0.width;
    return ret;
}
export function __wbindgen_generic_0000000000000001(arg0, arg1) {
    // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [Externref, Externref], shim_idx: 229, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
    const ret = makeMutClosure(arg0, arg1, wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined_______true__53);
    return ret;
}
export function __wbindgen_generic_0000000000000002(arg0, arg1) {
    // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [Externref], shim_idx: 279, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
    const ret = makeMutClosure(arg0, arg1, wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___wasm_bindgen_5c5b33c7748f97a8___JsValue______true_);
    return ret;
}
export function __wbindgen_generic_0000000000000003(arg0, arg1) {
    // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [Externref], shim_idx: 53, ret: Result(Unit), inner_ret: Some(Result(Unit)) }, mutable: true }) -> Externref`.
    const ret = makeMutClosure(arg0, arg1, wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Array_web_sys_efc8dbce5600037c___features__gen_PlaneLayout__PlaneLayout___core_b36eff2f6df0eff___result__Result_____wasm_bindgen_5c5b33c7748f97a8___JsError___true_);
    return ret;
}
export function __wbindgen_generic_0000000000000004(arg0, arg1) {
    // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [NamedExternref("Array<any>")], shim_idx: 53, ret: Result(Unit), inner_ret: Some(Result(Unit)) }, mutable: true }) -> Externref`.
    const ret = makeMutClosure(arg0, arg1, wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Array_web_sys_efc8dbce5600037c___features__gen_PlaneLayout__PlaneLayout___core_b36eff2f6df0eff___result__Result_____wasm_bindgen_5c5b33c7748f97a8___JsError___true__56);
    return ret;
}
export function __wbindgen_generic_0000000000000005(arg0, arg1) {
    // Cast intrinsic for `Ref(String) -> Externref`.
    const ret = getStringFromWasm0(arg0, arg1);
    return ret;
}
export function __wbindgen_init_externref_table() {
    const table = wasm.__wbindgen_externrefs;
    const offset = table.grow(4);
    table.set(0, undefined);
    table.set(offset + 0, undefined);
    table.set(offset + 1, null);
    table.set(offset + 2, true);
    table.set(offset + 3, false);
}
function wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___wasm_bindgen_5c5b33c7748f97a8___JsValue______true_(arg0, arg1, arg2) {
    wasm.wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___wasm_bindgen_5c5b33c7748f97a8___JsValue______true_(arg0, arg1, arg2);
}

function wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Array_web_sys_efc8dbce5600037c___features__gen_PlaneLayout__PlaneLayout___core_b36eff2f6df0eff___result__Result_____wasm_bindgen_5c5b33c7748f97a8___JsError___true_(arg0, arg1, arg2) {
    const ret = wasm.wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Array_web_sys_efc8dbce5600037c___features__gen_PlaneLayout__PlaneLayout___core_b36eff2f6df0eff___result__Result_____wasm_bindgen_5c5b33c7748f97a8___JsError___true_(arg0, arg1, arg2);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

function wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Array_web_sys_efc8dbce5600037c___features__gen_PlaneLayout__PlaneLayout___core_b36eff2f6df0eff___result__Result_____wasm_bindgen_5c5b33c7748f97a8___JsError___true__56(arg0, arg1, arg2) {
    const ret = wasm.wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Array_web_sys_efc8dbce5600037c___features__gen_PlaneLayout__PlaneLayout___core_b36eff2f6df0eff___result__Result_____wasm_bindgen_5c5b33c7748f97a8___JsError___true__56(arg0, arg1, arg2);
    if (ret[1]) {
        throw takeFromExternrefTable0(ret[0]);
    }
}

function wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined_______true_(arg0, arg1, arg2, arg3) {
    wasm.wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined_______true_(arg0, arg1, arg2, arg3);
}

function wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined_______true__53(arg0, arg1, arg2, arg3) {
    wasm.wasm_bindgen_5c5b33c7748f97a8___convert__closures_____invoke___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined___js_sys_b61b360bc59783d9___Function_fn_wasm_bindgen_5c5b33c7748f97a8___JsValue_____wasm_bindgen_5c5b33c7748f97a8___sys__Undefined_______true__53(arg0, arg1, arg2, arg3);
}


const __wbindgen_enum_CodecState = ["unconfigured", "configured", "closed"];


const __wbindgen_enum_EncodedVideoChunkType = ["key", "delta"];


const __wbindgen_enum_HardwareAcceleration = ["no-preference", "prefer-hardware", "prefer-software"];


const __wbindgen_enum_LatencyMode = ["quality", "realtime"];


const __wbindgen_enum_VideoPixelFormat = ["I420", "I420P10", "I420P12", "I420A", "I420AP10", "I420AP12", "I422", "I422P10", "I422P12", "I422A", "I422AP10", "I422AP12", "I444", "I444P10", "I444P12", "I444A", "I444AP10", "I444AP12", "NV12", "RGBA", "RGBX", "BGRA", "BGRX"];
const WasmEditorHandleFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmeditorhandle_free(ptr, 1));
const WasmExportSessionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmexportsession_free(ptr, 1));

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

const CLOSURE_DTORS = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(state => wasm.__wbindgen_destroy_closure(state.a, state.b));

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function getStringFromWasm0(ptr, len) {
    return decodeText(ptr >>> 0, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function makeMutClosure(arg0, arg1, f) {
    const state = { a: arg0, b: arg1, cnt: 1 };
    const real = (...args) => {

        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally {
            state.a = a;
            real._wbg_cb_unref();
        }
    };
    real._wbg_cb_unref = () => {
        if (--state.cnt === 0) {
            wasm.__wbindgen_destroy_closure(state.a, state.b);
            state.a = 0;
            CLOSURE_DTORS.unregister(state);
        }
    };
    CLOSURE_DTORS.register(real, state, state);
    return real;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;


let wasm;
export function __wbg_set_wasm(val) {
    wasm = val;
}
